import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import setShowReadingPane from 'owa-mail-module-orchestrator/lib/actions/setShowReadingPane';
import setShowListPane from 'owa-mail-module-orchestrator/lib/actions/setShowListPane';
import { mailSxSCleanupRouteHandler } from './mailSxSRouteHandler';
import selectRow from '../orchestrators/selectRow';

export interface SearchRouteParameters {
    rowId?: string;
}

export default function searchRouteHandler(parameters: SearchRouteParameters) {
    if (
        getUserConfiguration().UserOptions.GlobalReadingPanePositionReact ===
        ReadingPanePosition.Off
    ) {
        setShowReadingPane(false);
        setShowListPane(true);
    }

    if (parameters.rowId) {
        selectRow(parameters.rowId);
    }
}

export function searchCleanupRouteHandler(
    oldRoute?: string[],
    oldParameters?: any,
    newRoute?: string[],
    newParameters?: any
): boolean {
    const wasInSxS = !!oldRoute && oldRoute.some(value => value == 'sxs');

    if (wasInSxS) {
        mailSxSCleanupRouteHandler(oldRoute, oldParameters, newRoute, newParameters);
        setShowReadingPane(false);
    }

    return false;
}
